import createEntity from "./createEntity.js";
import usersView from "./users.view.js";
import videosView from "./videos.view.js";
import watchHistory from "./history.view";
import dashboard from "./dashboard.view";
import tenants from './tenants.view';
import tenantInfoView from "./tenantInfo.view";
import defaultView from "./default.view";
import trainerProfileView from "./trainerStats.view";
import trainerProfileEdit from "./trainerProfile.view";
import trainerVideosView from "./trainerVideos.view"
import leaderboard from "./leaderboard.js"

let userList = createEntity();
let allTenantsList = createEntity();

const state = {
    selectedTenant: 0,
    hideSidebar: false
};

const mutations = {

    setSelectedTenant(state, selectedTenant) {

        state.selectedTenant = selectedTenant
    },

    hideSidebar(state, hideSidebar) {

        state.hideSidebar = !state.hideSidebar;
    }
};

const getters = {
    selectedTenant(state) {
        return state.selectedTenant;
    }
};

const actions = {

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        userList,
        usersView,
        videosView,
        watchHistory,
        dashboard,
        leaderboard,
        tenants,
        tenantInfoView,
        allTenantsList,
        defaultView,
        trainerProfileView,
        trainerProfileEdit,
        trainerVideosView
    }
}